const sizeFilterId = 'filter.v.option.size';
const lengthFilterId = 'filter.p.m.custom.shop_by_length';

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}
function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();

}

class FacetFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);
        }, 500);


        const facetForm = this.querySelector('form');
        facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

        const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
        if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
        FacetFiltersForm.filterDrawer()

        const filterlable = document.querySelectorAll('.filterDrawerCheckbox');
        const moreBtns = document.querySelectorAll('[data-more-btn]:checked');
        filterlable.forEach(label => {
            label.addEventListener('click', function (e) {
                e.preventDefault();
                const valueFilter = e.currentTarget.querySelector('input').value;
                const mailEleemtn = document.getElementById('styleFilter');
                mailEleemtn.querySelector(`input[value='${valueFilter}']`).click();
            })
        })

        if(moreBtns.length && document.querySelector('.c-collectionsFilterStyle__button--moreButton') != null){
            // console.log('moreee if',moreBtns);
          document.querySelector('.c-collectionsFilterStyle__button--moreButton').classList.add('c-collectionsFilterStyle__button--isActiveMoreButton');
        } else{
            // console.log('moreee else',moreBtns);
          document.querySelector('.c-collectionsFilterStyle__button--moreButton').classList.remove('c-collectionsFilterStyle__button--isActiveMoreButton');
        }
        const res = parseInt(document.querySelector('#ProductCount').dataset.prdCount);

		checkProduct()

		const countcontainer = document.getElementById('ProductCount');
        const countcontainerDesktop = document.getElementById('ProductCountDesktop');
        const diff =  res - $('#product-grid .grid:hidden').length;

		if($('#product-grid .grid:visible').length > 1){
			countcontainer.innerHTML = 'Showing ' + diff + ' Results';
		} else{
			countcontainer.innerHTML = 'Showing ' + diff + ' Result';
		}
		if(countcontainerDesktop){
			if($('#product-grid .grid:visible').length > 1){
				countcontainerDesktop.innerHTML = 'Showing ' + diff + ' Results';
			} else{
				countcontainerDesktop.innerHTML = 'Showing ' + diff + ' Result';
			}
		}
    }

    static setListeners() {
        const onHistoryChange = (event) => {
            const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
            if (searchParams === FacetFiltersForm.searchParamsPrev) return;
            FacetFiltersForm.renderPage(searchParams, null, false);
        };
        window.addEventListener('popstate', onHistoryChange);
    }

    static toggleActiveFacets(disable = true) {
        document.querySelectorAll('.js-facet-remove').forEach((element) => {
            element.classList.toggle('disabled', disable);
        });
    }

    static renderPage(searchParams, event, updateURLHash = false) {

		searchParams = searchParams + `&filter.v.availability=1` // filter in stock

        FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm.getSections();
        const countContainer = document.getElementById('ProductCount');
        const countContainerDesktop = document.getElementById('ProductCountDesktop');
        document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
        if (countContainer) {
            countContainer.classList.add('loading');
        }
        if (countContainerDesktop) {
            countContainerDesktop.classList.add('loading');
        }

        sections.forEach((section) => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
            const filterDataUrl = (element) => element.url === url;

            FacetFiltersForm.filterData.some(filterDataUrl)
                ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
                : FacetFiltersForm.renderSectionFromFetch(url, event);
        });

        if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

        

        FacetFiltersForm.filterDrawer()
    }

    static renderSectionFromFetch(url, event) {
        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = responseText;
                FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
                FacetFiltersForm.renderFilters(html, event);
                FacetFiltersForm.renderProductGridContainer(html);
                FacetFiltersForm.renderProductCount(html);
                if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);


                //collection page size swatches quick shop start
                $("li.grid .collectSelect option").each(function () {
                    var option_value = $(this).val();
                    var option_text = $(this).text();
                    var option_text1 = $(this).text();
                    var option_stock = $(this).attr("stock");

                    if (option_text.includes(" / ")) {
                        var option_value_split = option_text.split(" / ");

                        if (option_value_split[1] == "Small" || option_value_split[1] == "small") {
                            option_value_split[1] = "S";
                        } else if (option_value_split[1] == "Medium" || option_value_split[1] == "medium") {
                            option_value_split[1] = "M";
                        } else if (option_value_split[1] == "Large" || option_value_split[1] == "large") {
                            option_value_split[1] = "L";
                        } else if (option_value_split[1] == "XLarge" || option_value_split[1] == "Xlarge" || option_value_split[1] == "xlarge" || option_value_split[1] == "xLarge") {
                            option_value_split[1] = "XL";
                        } else if (option_value_split[1] == "2XLarge" || option_value_split[1] == "2xlarge" || option_value_split[1] == "2xLarge" || option_value_split[1] == "2Xlarge") {
                            option_value_split[1] = "2XL";
                        } else if (option_value_split[1] == "3XLarge" || option_value_split[1] == "3xlarge" || option_value_split[1] == "3xLarge" || option_value_split[1] == "3Xlarge") {
                            option_value_split[1] = "3XL";
                        } else if (option_value_split[1] == "4XLarge" || option_value_split[1] == "4xlarge" || option_value_split[1] == "4xLarge" || option_value_split[1] == "4Xlarge") {
                            option_value_split[1] = "4XL";
                        } else if (option_value_split[1] == "5XLarge" || option_value_split[1] == "5xlarge" || option_value_split[1] == "5xLarge" || option_value_split[1] == "5Xlarge") {
                            option_value_split[1] = "5XL";
                        } else {
                            option_value_split[1];
                        }

                        if ((option_value_split[0] === "crew") || (option_value_split[0] === "Crew")) {
                            var sw_parent = $(this).parent().siblings(".pack-size-swatch-main").find(".swatch-crew-tab");
                            //on collection page
                            $(sw_parent).append(`
	    			<div variant-id="${option_value}" class="pack-product swatch-box ${option_stock}">
	    				<span>${option_value_split[1]}</span>
	    			</div>
	    		`);
                        } else if ((option_value_split[0] === "v-neck") || (option_value_split[0] === "V-Neck") || (option_value_split[0] === "V-neck") || (option_value_split[0] === "v-Neck")) {
                            //on collection page
                            var sw_parent = $(this).parent().siblings(".pack-size-swatch-main").find(".swatch-v-neck-tab");
                            //on collection page
                            $(sw_parent).append(`
	    			<div variant-id="${option_value}" class="pack-product swatch-box ${option_stock}">
	    				<span>${option_value_split[1]}</span>
	    			</div>
	    		`);
                        }
                    }
                });

                $("li.grid").mouseleave(function () {
                    $(this).find(".quick-shop").removeClass("quick-shop-not-visible");
                    $(this).find(".swatch-boxes-main").removeClass("swatch-visible");

                    $(".pack-size-swatch-main .swatch-crew-tab").addClass("active-pack");
                    $(".pack-size-swatch-main").removeClass("swatch-visible");
                    $(".pack-size-swatch-main .swatch-v-neck-tab").hide();
                    $(this).find(".pack-boxes-swatch-main").removeClass("swatch-visible");
                });

            });
    }

    static renderSectionFromCache(filterDataUrl, event) {
        const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    }

    static renderProductGridContainer(html) {
        document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('ProductGridContainer').innerHTML;

        document
            .getElementById('ProductGridContainer')
            .querySelectorAll('.scroll-trigger')
            .forEach((element) => {
                element.classList.add('scroll-trigger--cancel');
            });

		FacetFiltersForm.handleBadgeCountdown()
    }

	static handleBadgeCountdown() { // restart Kit expired scripts
		const badgeCountdownEls = document.querySelectorAll('.badge-countdown')

		if (badgeCountdownEls.length) {
			badgeCountdownEls.forEach(el => {
				const oldScript = el.querySelector('script')

				if (oldScript) {
					const scriptContent = oldScript.innerHTML

					oldScript.parentNode.removeChild(oldScript)

					const newScript = document.createElement('script')
					newScript.text = scriptContent

					el.appendChild(newScript)
				}
			})
		}
	}

    static renderProductCount(html) {
        const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
        var res = parseInt(count.split(' ')[1]);

		checkProduct()

		const countcontainer = document.getElementById('ProductCount');
        const countcontainerDesktop = document.getElementById('ProductCountDesktop');
        const diff =  res - $('#product-grid .grid:hidden').length;

		if($('#product-grid .grid:visible').length > 1){
			countcontainer.innerHTML = 'Showing ' + diff + ' Results';
		} else{
			countcontainer.innerHTML = 'Showing ' + diff + ' Result';
		}
		if(countcontainerDesktop){
			if($('#product-grid .grid:visible').length > 1){
				countcontainerDesktop.innerHTML = 'Showing ' + diff + ' Results';
			} else{
				countcontainerDesktop.innerHTML = 'Showing ' + diff + ' Result';
			}
		}
       
    }

    static renderFilters(html, event) {

        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        const facetDetailsElements = parsedHTML.querySelectorAll(
            '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter, #filterDrawer .js-filter'
        );
        const matchesIndex = (element) => {
            const jsFilter = event ? event.target.closest('.js-filter') : undefined;
            return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
        };
        const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
        const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

        facetsToRender.forEach((element) => {
            document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
        });

        FacetFiltersForm.renderActiveFacets(parsedHTML);
        FacetFiltersForm.renderAdditionalElements(parsedHTML);

        if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

        const filterlable = document.querySelectorAll('.filterDrawerCheckbox');
        filterlable.forEach(label => {
            label.addEventListener('click', function (e) {
                e.preventDefault();
                // console.log('e.currentTarget.value=======>', e.currentTarget.querySelector('input').value);
                const valueFilter = e.currentTarget.querySelector('input').value;
                const mailEleemtn = document.getElementById('styleFilter');
                const moreBtns = document.querySelectorAll('[data-more-btn] input[type=checkbox]:checked');
                // console.log('========>', mailEleemtn.querySelector(`input[value="${valueFilter}"]`));
                mailEleemtn.querySelector(`input[value='${valueFilter}']`).click()

            })
        })

    }

    static renderActiveFacets(html) {
        const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

        activeFacetElementSelectors.forEach((selector) => {
            const activeFacetsElement = html.querySelector(selector);
            if (!activeFacetsElement) return;
            document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
        });

        FacetFiltersForm.toggleActiveFacets(false);
    }

    static renderAdditionalElements(html) {
        const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

        mobileElementSelectors.forEach((selector) => {
            if (!html.querySelector(selector)) return;
            document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
        });

    }

    static renderCounts(source, target) {
        const targetElement = target.querySelector('.facets__selected');
        const sourceElement = source.querySelector('.facets__selected');

        const targetElementAccessibility = target.querySelector('.facets__summary');
        const sourceElementAccessibility = source.querySelector('.facets__summary');

        if (sourceElement && targetElement) {
            target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
        }

        if (targetElementAccessibility && sourceElementAccessibility) {
            target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
        }
    }

    static updateURLHash(searchParams) {
        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }

    static getSections() {
        return [
            {
                section: document.getElementById('product-grid').dataset.id,
            },
        ];
    }

    createSearchParams(form) {
        const formData = new FormData(form);

        this.setLocalValue(formData);

        return new URLSearchParams(formData).toString();
    }

    onSubmitForm(searchParams, event) {
        FacetFiltersForm.renderPage(searchParams, event);
    }

	setLocalValue(formData = {}) {
		const sizeValue = formData.get(sizeFilterId)
		const lengthValue = formData.get(lengthFilterId)

		if (sizeValue !== null) {
			localStorage.setItem(sizeFilterId, sizeValue === '' ? '' : sizeValue);
		}

		if (lengthValue !== null) {
			localStorage.setItem(lengthFilterId, lengthValue === '' ? '' : lengthValue);
		}
	}

  static getLocalValue() {

    const selectSizeEl = document.querySelector('.filter-v-option-size-select .select-selected');
    const selectLengthEl = document.querySelector('.filter-p-m-custom-shop_by_length-select .select-selected');

    if (!selectSizeEl && !selectLengthEl) return

    const sizeLocalValue = localStorage.getItem(sizeFilterId);
    const lengthLocalValue = localStorage.getItem(lengthFilterId);

    const inputs = []
    if (sizeLocalValue) {
      const inputSize = document.querySelector(`.filter-v-option-size-select input[value='${sizeLocalValue}']`)
      if (inputSize) {
        inputs.push(inputSize)
        selectSizeEl.innerText = sizeLocalValue;
      }
    }
    if (lengthLocalValue) {
      const inputLength = document.querySelector(`.filter-p-m-custom-shop_by_length-select input[value='${lengthLocalValue}']`)
      if (inputLength) {
        inputs.push(inputLength)
        selectLengthEl.innerText = lengthLocalValue;
      }
    }
    inputs.forEach((input) => input.click())
  }

    onSubmitHandler(event) {
        event.preventDefault();

        const sortFilterForms = document.querySelectorAll('facet-filters-form form');
        if (event.srcElement.className == 'mobile-facets__checkbox') {
            const searchParams = this.createSearchParams(event.target.closest('form'));
            this.onSubmitForm(searchParams, event);
        } else {
            const forms = [];
            const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

            sortFilterForms.forEach((form) => {
                if (!isMobile) {
                    if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
                        const noJsElements = document.querySelectorAll('.no-js-list');
                        noJsElements.forEach((el) => el.remove());
                        forms.push(this.createSearchParams(form));
                    }
                } else if (form.id === 'FacetFiltersFormMobile') {
                    forms.push(this.createSearchParams(form));
                }
            });
            this.onSubmitForm(forms.join('&'), event);
        }
    }

    onActiveFilterClick(event) {
        event.preventDefault();
        FacetFiltersForm.toggleActiveFacets();
        const url =
            event.currentTarget.href.indexOf('?') == -1
                ? ''
                : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
        FacetFiltersForm.renderPage(url);
    }

    static filterDrawer() {
        const navDrawer = document.querySelector('.c-collectionsFilter1__drawer');
        const navActive = 'c-drawer--isOpen';
        const navOverlay = document.querySelector('.c-collectionsFilter1__overlay');
        const Overlay = 'c-overlay';
        const navBtn = document.querySelector('.c-collectionsFilterStyle__button--moreButton');

        if(navBtn != null) {
            document.querySelector('.c-collectionsFilterStyle__button--moreButton').addEventListener('click', function () {
                navDrawer.classList.add(navActive);
                navOverlay.classList.add(Overlay);
            });
    
            document.querySelector('.c-collectionsFilter1__close').addEventListener('click', function () {
                navDrawer.classList.remove(navActive);
                navOverlay.classList.remove(Overlay);
            });
    
            document.querySelector('.c-collectionsFilter1__close').addEventListener('click', function (event) {
                event.preventDefault();
            });
    
            document.addEventListener('mousedown', function (e) {
                const container = navDrawer;
    
                if (!container.contains(e.target)) {
                    container.classList.remove(navActive);
                    container.classList.remove(Overlay);
                    navOverlay.classList.remove(Overlay);
                }
            });
        }

    }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.getLocalValue();

class PriceRange extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll('input').forEach((element) =>
            element.addEventListener('change', this.onRangeChange.bind(this))
        );
        this.setMinAndMaxValues();
    }

    onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget);
        this.setMinAndMaxValues();
    }

    setMinAndMaxValues() {
        const inputs = this.querySelectorAll('input');
        const minInput = inputs[0];
        const maxInput = inputs[1];
        if (maxInput.value) minInput.setAttribute('max', maxInput.value);
        if (minInput.value) maxInput.setAttribute('min', minInput.value);
        if (minInput.value === '') maxInput.setAttribute('min', 0);
        if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    }

    adjustToValidValues(input) {
        const value = Number(input.value);
        const min = Number(input.getAttribute('min'));
        const max = Number(input.getAttribute('max'));

        if (value < min) input.value = min;
        if (value > max) input.value = max;
    }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
    constructor() {
        super();
        const facetLink = this.querySelector('a');
        facetLink.setAttribute('role', 'button');
        facetLink.addEventListener('click', this.closeFilter.bind(this));
        facetLink.addEventListener('keyup', (event) => {
            event.preventDefault();
            if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
        });


		facetLink?.addEventListener('click', () => {
			const selectFacetsEl = document.querySelectorAll('.select-dropdown.facets .select-selected')
			const test = document.querySelectorAll('.select-dropdown.facets input.clear')

			test?.forEach(t => t.checked = true)
			selectFacetsEl?.forEach(t => t.innerText = '-')
		})
    }

    closeFilter(event) {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        if(document.querySelector('.c-collectionsFilterStyle__button--moreButton') != null){
          document.querySelector('.c-collectionsFilterStyle__button--moreButton').classList.remove('c-collectionsFilterStyle__button--isActiveMoreButton');
        }
        form.onActiveFilterClick(event);
            document.querySelectorAll('.facets__item input:checked').forEach((element) => {
            element.click()
        });
        
    }
}

customElements.define('facet-remove', FacetRemove);

function checkProduct() {
	$(`[name="${sizeFilterId}"]:checked`).each(function(i,ele){
		const selVal = $(ele).val()
		const soldoutPrd = $(`[data-var-title='${selVal}'].soldout`)

		if (soldoutPrd.length) soldoutPrd.closest('.grid').css('display','none')
	})

	$(`[name="${lengthFilterId}"]:checked`).each(function(i,ele){
		const size = $('[name="filter.v.option.size"]:checked')
		const sizeVal = size?.val()

		const selVal = $(ele).val()
		const soldoutPrd = $(`[data-var-title='${sizeVal} / ${selVal}'].soldout`)

		if (soldoutPrd.length) soldoutPrd.closest('.grid').css('display','none')
	})

	const countContainer = document.getElementById('ProductCount')
	const diff = $('#product-grid .grid').length - $('#product-grid .grid:hidden').length

	countContainer.innerHTML = 'Showing ' + diff + ' Results'
}

checkProduct()
